import React, { useState } from "react"

import { useHistory } from "react-router-dom"
import { gql, useQuery } from "urql"

import { path } from "~Tutor/TutorRoutes"
import { StyledLink, WithLoadingIndicator } from "~tailwindui/Basics"
import Table from "~tailwindui/Table/Table"

import LocalTime from "components/LocalTime"

const BilledSessions = () => {
  const history = useHistory()
  const [page, setPage] = useState(1)
  const [result] = useQuery({
    query: billedSessionsQuery,
    variables: { page },
  })

  return (
    <WithLoadingIndicator
      result={result}
      error="An error occurred while loading your billed sessions"
    >
      {({ data: { viewer } }) => (
        <>
          <Table
            title="Billed Sessions"
            changePage={setPage}
            data={viewer.sessions}
            collapsedByDefault
            rowCallback={({ id }) => {
              history.push(path("sessionDetails", { id }))
            }}
            cols={[
              {
                header: "Study Group",
                value: session =>
                  session.studyGroup ? (
                    <StyledLink
                      key={session.studyGroup.id}
                      to={path("studyGroupDetails", {
                        id: session.studyGroup.id,
                      })}
                    >
                      <span className="flex items-center">
                        {session.studyGroup.name}
                      </span>
                    </StyledLink>
                  ) : null,
              },
              { header: "Subject", value: session => session.subject.name },
              {
                header: "Students",
                value: session => (
                  <ul key={session.id}>
                    {session.students.map(student => (
                      <li key={student.id}>
                        <StyledLink
                          to={path("studentDetails", {
                            id: student.id,
                          })}
                        >
                          {student.fullName}
                        </StyledLink>
                      </li>
                    ))}
                  </ul>
                ),
              },
              {
                header: "Date",
                value: session => (
                  <div key={session.id} className="min-w-[80px]">
                    <LocalTime
                      format="ddd MMM D, YYYY"
                      timestamp={session.startsAt}
                    />
                    <br />
                    <LocalTime omitDate timestamp={session.startsAt} />
                    &mdash;
                    <LocalTime omitDate timestamp={session.endsAt} />
                  </div>
                ),
              },
              {
                header: "Duration",
                value: session => session.formattedBilledDuration,
              },
            ]}
          />
        </>
      )}
    </WithLoadingIndicator>
  )
}

const billedSessionsQuery = gql`
  query BilledSessions($page: Int!) {
    viewer {
      sessions(filters: { billState: billed }, page: $page) {
        currentPage
        totalPages
        data {
          id
          startsAt
          endsAt
          formattedBilledDuration
          students {
            id
            fullName
          }
          subject {
            name
          }
          studyGroup {
            id
            name
          }
        }
      }
    }
  }
`

export default BilledSessions
